<style scoped>
    .vcenter {
        display: inline-block;
        vertical-align: middle;
        float: none;
    }
</style>
<template>
    <div style="padding:0px; margin:-5px" class="page-header-style">
        <div class="row" style="padding:10px; margin:0px">
            <div class="col-sm-1" style="padding:0px; overflow:hidden; " v-if="imageUrl">
                <img v-bind:src="imageUrl" height="80" style="overflow: hidden">
            </div>
            <div v-bind:class="{'col-sm-11':imageUrl, 'col-sm-12':!imageUrl}">
                <div class="col-sm-12" style="border-bottom:1px solid #18bc9c;">
                    <div class="col-sm-5">
                        <h4 style="margin-top:0px;margin-bottom:5px"><span class="text-primary">{{patient.firstName}} {{patient.lastName}}</span></h4>
                    </div>
                    <div class="col-sm-3">
                        <p style="margin:0px">
                            <small>DOB :</small> {{(dob)}} <br />
                            <small>Ward :</small> {{patient.wardName}}
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <div style="margin:0px">
                            <p v-if="patient.generalPractitioner != undefined" style="margin:0px">
                                <span class="pull-left"><strong>{{patient.generalPractitioner.name}}</strong> (GP)        </span><br />
                                <span class="pull-left"><small>{{patient.generalPractitioner.phoneNumber}}</small>    </span><br />
                            </p>
                        </div>
                    </div>
                </div>
                
                <div class="col-sm-12  col-xs-12" style="margin-top:5px; margin-bottom:0px;">
                    <ul class="nav nav-pills pull-right">
                        <li :class="{ 'active': $route.name === 'patient.medstock' }">
                            <router-link :to="{ path: '/patient/'+patient.id+'/'+carehomeid+'/medstock', params: { carehomeid: carehomeid, wardid: patient.wardId, patientid: patient.id}}">
                                Med Stock
                            </router-link>
                        </li>
                        <li :class="{ 'active': $route.name === 'patient.medprofile' }">
                            <router-link :to="{ path: '/patient/'+patient.id+'/'+carehomeid+'/medprofile', params: { carehomeid: carehomeid, wardid: patient.wardId, patientid: patient.id}}">
                                Med Profile
                            </router-link>
                        </li>
                        <li :class="{ 'active': $route.name === 'patient.orders' }">
                            <router-link exact-active-class="active" :to="{ path: '/patient/'+patient.id+'/'+carehomeid+'/orders', params: { carehomeid: carehomeid, wardid: patient.wardId, patientid: patient.id}}">
                                Orders
                            </router-link>
                        </li>
                        <li :class="{ 'active': $route.name === 'patient.marhistory' }">
                            <router-link :to="{ path: '/patient/'+patient.id+'/'+carehomeid+'/marhistory', params: { carehomeid: carehomeid, wardid: patient.wardId, patientid: patient.id}}">
                                Mar History
                            </router-link>
                        </li>
                        <li :class="{ 'active': $route.name === 'patient.reports' }">
                            <router-link :to="{ path: '/patient/'+patient.id+'/'+carehomeid+'/reports', params: { carehomeid: carehomeid, patientid: patient.id}}">
                                Print Reports
                            </router-link>
                        </li>
                        <!--<li class="pull-right">
        <router-link :to="{ name: 'patient-edit', params: { carehomeid: carehomeid, patientid: patient.id}}">
            Edit Details
        </router-link>

    </li>-->
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { PatientDto } from './../../../dto/PatientDto'
    import Formatter from "../../corecontrols/formatters/Formatter"
    Formatter

    export default {
        props: ['patient', 'carehomeid'],
        data: function () {
            return {
                imageUrl: "",
                dob: ""
            }
        },
        watch: {
            patient: function () {
                if (this.$props.patient.imageId != undefined)
                    this.imageUrl = "api/image?id=" + this.$props.patient.imageId;

                this.dob = Formatter.FormatDate(this.$props.patient.dob)
            }
        },
        mounted: function () {
            console.log("Patient Header -----------------------------------------------", this.$props.patient);
            if (this.$props.patient.imageId != undefined)
                this.imageUrl = "api/image/" + this.$props.patient.imageId;
            this.dob = Formatter.FormatDate(this.$props.patient.dob)
        }
    }
</script>


// WEBPACK FOOTER //
// patientHeader.scp.html?d883feba